import dayjs from "dayjs";
import * as XLSX from "xlsx";

import { ITEM_KIND_LABELS } from "../components/CosteoShared";

import type { CostingMovement } from "~/types/costing";

/**
 * Export the Compras / Recepciones list to an .xlsx workbook. Pass the already
 * kg-converted rows (displayPurchases) so oil quantities / unit costs match the
 * UI. Amounts are written as raw numbers so Excel treats them numerically.
 */
export function exportPurchasesToExcel(
  movements: CostingMovement[],
  periodLabel: Map<string, string>,
  range: { from: string; to: string }
) {
  const rows = movements.map((m) => {
    const code =
      m.raw_materials?.code ?? m.oil_types?.code ?? m.products?.sku ?? "";
    const name =
      m.raw_materials?.name ??
      m.oil_types?.name ??
      m.products?.short_name ??
      "";
    return {
      Período: periodLabel.get(m.period_id) ?? "",
      Fecha: dayjs(m.movement_date).format("DD/MM/YYYY"),
      Código: code,
      Ítem: name,
      Tipo: ITEM_KIND_LABELS[m.item_kind],
      Documento: m.document_number ?? "",
      Origen: m.source_type === "manual" ? "Manual" : "Recepción",
      "Proveedor / Notas": m.notes ?? "",
      Cantidad: Number(m.quantity),
      "Costo Unitario": Number(m.unit_cost_clp),
      Total: Number(m.total_cost_clp),
    };
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [
    { wch: 10 }, // Período
    { wch: 12 }, // Fecha
    { wch: 14 }, // Código
    { wch: 40 }, // Ítem
    { wch: 18 }, // Tipo
    { wch: 16 }, // Documento
    { wch: 12 }, // Origen
    { wch: 32 }, // Proveedor / Notas
    { wch: 14 }, // Cantidad
    { wch: 16 }, // Costo Unitario
    { wch: 16 }, // Total
  ];
  XLSX.utils.book_append_sheet(wb, ws, "Compras");

  const suffix =
    range.from === range.to ? range.from : `${range.from}_a_${range.to}`;
  XLSX.writeFile(wb, `Compras_Recepciones_${suffix}.xlsx`);
}
